<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import VueCropper from 'vue-cropperjs';

   export default {
      page: {
         title: "Settings",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader, VueCropper },
      data() {
         return {
            title: "Settings",
            items: [
               {
                  text: "Settings",
                  active: true,
               },                   
            ],
            // time_status: '',
            admin_image: "",
            admin_name: "Clinic",          
            username: "clinic@medicino.com",
            password: "",
            password_confirmation: "",
            android_version: null,
            settings: {
               
            },  
            clinic: {},       
            maintenance: 0,
            maintenance_reason: "",
            booking_charge: 10,
            token: "",
            errors: {},
            image: '',
            preview_image: null,
            show_password: false,
            show_confirm_password: false,
             showCropper: false,
            cropperImage: "",
            cropperOptions: {
               aspectRatio: 1,
               viewMode: 1,
               dragMode: 'move',
               autoCropArea: 0.8,
               restore: false,
               guides: false,
               center: false,
               highlight: false,
               cropBoxMovable: true,
               cropBoxResizable: true,
               toggleDragModeOnDblclick: false,
            },
            isSquareCrop: true,
         };
      },
      mounted() {
    
      },
      created() {
         this.fetchSettings();
      },

      beforeDestroy() {
         // Clean up object URLs to prevent memory leaks
         if (this.cropperImage) {
            URL.revokeObjectURL(this.cropperImage);
         }
         if (this.preview_image) {
            URL.revokeObjectURL(this.preview_image);
         }
      },
      methods: {
         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 
         fetchSettings() {
            let url = "clinic/settings";         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData.clinic);
               this.clinic = responseData.clinic;
                        
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         setFile(e) {
            const file = e.target.files[0];
            if (file) {
               // Validate file type
               const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
               if (!allowedTypes.includes(file.type)) {
                  this.$swal("", "Please select a valid image file (JPG, JPEG, PNG)", "error");
                  return;
               }
               
               // Validate file size (max 5MB)
               if (file.size > 5 * 1024 * 1024) {
                  this.$swal("", "Image size should be less than 5MB", "error");
                  return;
               }
               
               this.cropperImage = URL.createObjectURL(file);
               this.showCropper = true;
            }
         },
         updateClinic() {
            
            this.getToken();
            this.errors = {};
            let formData = new FormData();
            formData.append("name", this.clinic.name);
            formData.append("email", this.clinic.username);           
            
            if(this.image) {
               formData.append('image', this.image);
            }

            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            this.loading = true;            
            
            this.$axios
               .post("clinic/ClinicProfileUpdate", formData, config)
               .then((response) => {
                  console.log(response);
                  if (response.data.status) {
                     var user = response.data.data[0];
                     console.log(user);
                     var medicino_clinic = {};
                     if (localStorage.getItem('medicino_clinic')) {
                        medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
                     }

                     medicino_clinic.username = user.username;
                     medicino_clinic.image = user.image;
                     // medicino_clinic.username = user.username;
                     medicino_clinic.name = user.name;

                     localStorage.setItem('medicino_clinic', JSON.stringify(medicino_clinic));
                     
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }

                  //this.clearForm();                  
                  this.$router.go().catch(()=>{});
               })
               .catch((error) => {

                  if (error.response) {
                     console.log(error.response);
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        //this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     //this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },
         changePassword() {

            this.getToken();
            this.errors = {};

            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            var data = JSON.stringify({
               "password": this.password,
               "password_confirmation": this.password_confirmation
            });
            
            this.loading = true;

            this.$axios
               .post("clinic/change-password", data, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.$router.push({ name: "settings" });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         timeDisplay(){

            let url = "clinic/display-time-status?clinic_id=" + this.clinic.clinic_id+ "&display_time=" + this.clinic.display_token_time+ "&display_name=" + this.clinic.display_name;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }

               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

            
         },


         clearForm() {
            this.password = "";
            this.password_confirmation = "";
            this.image = "";
            this.preview_image = "";
            this.showCropper = false;
            this.cropperImage = '';
            this.errors = {};
         },
         togglePassword() {
            if(this.show_password == false) {
               this.show_password = true;
            } else {
               this.show_password = false;
            }
         },

         toggleCurrentPassword() {
            if(this.show_current_password == false) {
               this.show_current_password = true;
            } else {
               this.show_current_password = false;
            }
         },

         toggleConfirmPassword() {
            if(this.show_confirm_password == false) {
               this.show_confirm_password = true;
            } else {
               this.show_confirm_password = false;
            }
         },

         // Crop functionality methods
         cropImage() {
            // Get cropped canvas
            const canvas = this.$refs.cropper.getCroppedCanvas({
               width: 400,
               height: 400,
               imageSmoothingEnabled: true,
               imageSmoothingQuality: 'high',
            });
            
            // Convert canvas to blob
            canvas.toBlob((blob) => {
               // Create a new file from the blob
               const croppedFile = new File([blob], 'cropped-image.jpg', {
                  type: 'image/jpeg',
                  lastModified: Date.now()
               });
               
               this.image = croppedFile;
               this.preview_image = URL.createObjectURL(blob);
               this.showCropper = false;
               
               // Clean up the cropper image URL
               if (this.cropperImage) {
                  URL.revokeObjectURL(this.cropperImage);
                  this.cropperImage = "";
               }
            }, 'image/jpeg', 0.9);
         },
         cancelCrop() {
            this.showCropper = false;
            // Clean up the cropper image URL
            if (this.cropperImage) {
               URL.revokeObjectURL(this.cropperImage);
               this.cropperImage = "";
            }
            // Reset file input
            this.$refs.fileinput.value = '';
         },
         toggleAspectRatio() {
            this.isSquareCrop = !this.isSquareCrop;
            this.cropperOptions.aspectRatio = this.isSquareCrop ? 1 : NaN;
            if (this.$refs.cropper) {
               this.$refs.cropper.setAspectRatio(this.cropperOptions.aspectRatio);
            }
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Clinic Details</h4>
                  <b-form @submit.prevent="updateClinic()">
                     <b-row>
                        <b-col md="4" lg="5" class="form-group">
                           <label class="control-label">Clinic Name <span class="text-danger">*</span></label>
                           <b-form-input v-model="clinic.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                           <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="5" lg="5" class="form-group">
                           <label class="control-label">Email <span class="text-danger">*</span></label>
                           <b-form-input v-model="clinic.username" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>

                           <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="3" lg="2" class="form-group">
                        </b-col>
                        <b-col md="9" lg="10" class="form-group">
                           <label class="control-label">Clinic image <span class="note">[Allowed Formats: jpg, jpeg, png]</span></label><br>
                           
                           <!-- Current clinic image -->
                           <img v-if="clinic.image && !preview_image" :src="$image_url + clinic.image" class="avatar-sm mb-2" alt="" />
                           
                           <!-- Preview of new/cropped image -->
                           <div v-if="preview_image" class="mt-2">
                              <img class="avatar-sm" :src="preview_image" alt="New Profile Preview">
                              <p class="text-muted small mt-1">New image preview - Click "Choose File" to select a different image</p>
                           </div>
                           
                           <input ref="fileinput" type="file" @change="setFile($event)" accept="image/*" class="form-control image-class"  v-bind:class="{ 'is-invalid': Boolean(errors.image) }"/>
                           
                           <div class="note">Leave this field empty if you don't want to add/edit the image</div>

                           <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" lg="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="submit-button mb-3" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Change Password</h4>
                  <b-form  @submit.prevent="changePassword()">
                     <b-row class="d-flex">
                        <b-col md="5" class="form-group">
                           <label class="control-label">Password</label>
                           <b-input-group>
                           <b-form-input type="password" v-model="password"  v-if="!show_password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                           <b-form-input type="text" v-model="password" v-else v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                           <b-input-group-text @click="togglePassword()">
                                 <i class="fas fa-eye" v-if="show_password"></i>
                                 <i class="fas fa-eye-slash" v-else></i>
                              </b-input-group-text>
                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-input-group>
                        </b-col>

                        <b-col md="5" class="form-group">
                           <label class="control-label">Confirm Password</label>
                           <b-input-group>
                                 <b-form-input type="password" v-model="password_confirmation" v-if="!show_confirm_password" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>
                                 <b-form-input type="text" v-model="password_confirmation" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }" v-else></b-form-input>
                                 <b-input-group-text @click="toggleConfirmPassword()">
                                    <i class="fas fa-eye" v-if="show_confirm_password"></i>
                                    <i class="fas fa-eye-slash" v-else></i>
                                 </b-input-group-text>
                                 <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>  
                           </b-input-group>                            
                        </b-col>

                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>
            <div class="card">
               <div class="card-body">
                  <div class="row">
                  <h4 class="card-title mb-3">Token Vending Machine</h4>
                 
                     <div class="form-group col-md-3">
                        <b-form-checkbox
                           id="checkbox-1"
                           v-model="clinic.display_token_time"
                           name="checkbox-1"
                           value="1"
                           unchecked-value="2"
                        >
                        <span class="ms-2"> Display Time</span>
                        </b-form-checkbox>
                     </div>
                     <div class="form-group col-md-3">
                        <b-form-checkbox
                           v-model="clinic.display_name"
                           name="premium"
                           value="1"
                           unchecked-value="2"
                           >
                           <span class="ms-2"> Display Name</span>
                        </b-form-checkbox>
                     </div>

                     
                     <b-col md="" class="form-group d-flex align-items-end">

                        <b-button type="button" class="mr-3 submit-button" variant="primary" @click="timeDisplay()">Update</b-button>
                     </b-col>
                  </div>
                 
               </div>
            </div>
            <!-- <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Charges</h4>
                  <b-form>
                     <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Offline Service Charge <br>(in Rs.)</label>
                           <input type="text" class="form-control" v-model="booking_charge"  v-bind:class="{ 'is-invalid': Boolean(errors.booking_charge) }"/>
                           <div v-for="(val, index) in errors.booking_charge" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="3" class="form-group">
                           <label class="control-label">Regular Delivery Charge per KM <br>(in Rs.)</label>
                           <input type="text" class="form-control" v-model="booking_charge"  v-bind:class="{ 'is-invalid': Boolean(errors.booking_charge) }"/>
                           <div v-for="(val, index) in errors.booking_charge" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="3" class="form-group">
                           <label class="control-label">Express Delivery Charge (Fixed) <br>(in Rs.)</label>
                           <input type="text" class="form-control" v-model="booking_charge"  v-bind:class="{ 'is-invalid': Boolean(errors.booking_charge) }"/>
                           <div v-for="(val, index) in errors.booking_charge" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        
                        <b-col md="3" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div> -->


            <!-- <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Social Media Links</h4>
                  <b-form>
                     <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Facebook</label>
                           <b-form-input v-model="facebook" v-bind:class="{ 'is-invalid': Boolean(errors.facebook) }"></b-form-input>
                           <div v-for="(val, index) in errors.facebook" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Twitter</label>
                           <b-form-input v-model="twitter" v-bind:class="{ 'is-invalid': Boolean(errors.twitter) }"></b-form-input>
                           <div v-for="(val, index) in errors.twitter" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Instagram</label>
                           <b-form-input v-model="instagram" v-bind:class="{ 'is-invalid': Boolean(errors.instagram) }"></b-form-input>
                           <div v-for="(val, index) in errors.instagram" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div> -->


            <!-- <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Maintenance Mode</h4>
                  <b-form>
                     <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Maintenance</label>
                           <select v-model="maintenance" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.maintenance) }">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.maintenance" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance</label>
                           <b-form-input v-model="maintenance_reason" v-bind:class="{ 'is-invalid': Boolean(errors.reason) }"></b-form-input>
                           <div v-for="(val, index) in errors.reason" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>

               </div>
            </div> -->

            <!-- <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Version Control</h4>
                  <b-form>
                     <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Android</label>
                           <b-form-input v-model="android_version" v-bind:class="{ 'is-invalid': Boolean(errors.android) }"></b-form-input>
                           <div v-for="(val, index) in errors.android" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <label class="control-label">IOS</label>
                           <b-form-input v-model="ios_version" v-bind:class="{ 'is-invalid': Boolean(errors.ios) }"></b-form-input>
                           <div v-for="(val, index) in errors.ios" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div> -->


         </div>
      </div>

      <!-- Image Cropper Modal -->
      <b-modal 
         v-model="showCropper" 
         title="Crop Profile Image" 
         size="lg" 
         centered 
         hide-footer
         @hide="cancelCrop"
         class="cropper-modal">
         
         <div class="cropper-container">
            <vue-cropper
               ref="cropper"
               :src="cropperImage"
               :aspect-ratio="cropperOptions.aspectRatio"
               :view-mode="cropperOptions.viewMode"
               :drag-mode="cropperOptions.dragMode"
               :auto-crop-area="cropperOptions.autoCropArea"
               :restore="cropperOptions.restore"
               :guides="cropperOptions.guides"
               :center="cropperOptions.center"
               :highlight="cropperOptions.highlight"
               :crop-box-movable="cropperOptions.cropBoxMovable"
               :crop-box-resizable="cropperOptions.cropBoxResizable"
               :toggle-drag-mode-on-dblclick="cropperOptions.toggleDragModeOnDblclick"
               class="cropper-wrapper">
            </vue-cropper>
         </div>
         
         <div class="cropper-controls mt-3">
            <div class="d-flex justify-content-between align-items-center">
               <div>
                  <button type="button" class="btn btn-outline-primary btn-sm" @click="toggleAspectRatio">
                     <i class="bx bx-crop"></i> 
                     {{ isSquareCrop ? 'Free Ratio' : 'Square Crop' }}
                  </button>
               </div>
               <div>
                  <button type="button" class="btn btn-secondary me-2" @click="cancelCrop">
                     <i class="bx bx-x"></i> Cancel
                  </button>
                  <button type="button" class="btn btn-primary" @click="cropImage">
                     <i class="bx bx-check"></i> Crop & Save
                  </button>
               </div>
            </div>
         </div>
      </b-modal>
   </Layout>
</template>

<style scoped>
.cropper-container {
   height: 400px;
   width: 100%;
}

.cropper-wrapper {
   height: 100%;
   width: 100%;
}

.cropper-controls {
   border-top: 1px solid #e9ecef;
   padding-top: 1rem;
}

.avatar-sm {
   width: 80px;
   height: 80px;
   object-fit: cover;
   border-radius: 8px;
   border: 2px solid #e9ecef;
}

.avatar-md {
   width: 120px;
   height: 120px;
   object-fit: cover;
   border-radius: 8px;
   border: 2px solid #e9ecef;
}

/* Cropper modal specific styles */
.cropper-modal .modal-dialog {
   max-width: 800px;
}

.cropper-modal .modal-body {
   padding: 1rem;
}

.note {
   font-size: 12px;
   color: #6c757d;
   font-style: italic;
}
</style>
